export default __webpack_public_path__ + "static/media/swords-emblem.5347dec2.png";